export default function getCustomerOrders(customer = {}, orders = []) {
  if (Object.keys(customer).length === 0) return []
  if (orders.length === 0) return []
  return orders.filter(order => order.customer.id === customer.id)
}
